<template>
    <div id="monitor" @click="areaNameListShow = false">
        <div class="mapInfoWindow" ref="mapInfoWindow">
            <ul class="windowTitle">
                <li :class="thisInfo == 1 ? 'thisInfo' : ''" @click="windowEvent(1)">设备信息</li>
            </ul>
            <ul class="windowMain" v-show="thisInfo == 1">
                <li>
                    <p>设备编号</p>
                    <p>{{ baseInfoData.num }}</p>
                </li>
                <li>
                    <p>通讯方式</p>
                    <p>{{ baseInfoData.type == 1 ? 'NB' : 'WIFI' }}</p>
                </li>
                <li>
                    <p>用气类型</p>
                    <p>{{ baseInfoData.gasType== 1 ? "液化天然气" : "液化石油气" }}</p>
                </li>
                <li>
                    <p>联系电话</p>
                    <p>{{ baseInfoData.telephone }}</p>
                </li>
                <li>
                    <p>紧急联系人</p>
                    <p>{{ baseInfoData.name }}</p>
                </li>
                <li>
                    <p>设备地址</p>
                    <p>{{ baseInfoData.address }}</p>
                </li>
                <li>
                    <p>昨日最大压力值</p>
                    <p>{{ baseInfoData.minAD }}</p>
                </li>
                <li>
                    <p>失联报警</p>
                    <p>{{ baseInfoData.lostcontact }} 次</p>
                </li>
                <li class="noMargin">
                    <p>用户远程关阀次数</p>
                    <p>{{ baseInfoData.valveClose }} 次</p>
                </li>
                <li class="noMargin">
                    <p>已使用天数</p>
                    <p>{{ baseInfoData.now }} 天</p>
                </li>
            </ul>
        </div>
        <!-- 头部 -->
        <div class="head">
            <p @click="goBack">进入后台</p>
        </div>
        <!-- 主体 -->
        <div class="monitorMain a">
            <!-- 左侧 -->
            <div class="left b">
                <!-- 数据总览 -->
                <div class="dataTotal">
                    <div class="itemTitle">
                        <p>数据总览</p>
                    </div>
                    <ul class="itemMain">
                        <li>
                            <img src="../assets/imgs/monitor/overviewIcon.png" alt="" />
                            <div>
                                <p>设备数量</p>
                                <p>{{ dataView.deviceTotal }}</p>
                            </div>
                        </li>
                        <li>
                            <img src="../assets/imgs/monitor/overviewIcon.png" alt="" />
                            <div>
                                <p>用户数量</p>
                                <p>{{ dataView.userNum }}</p>
                            </div>
                        </li>
                        <li>
                            <img src="../assets/imgs/monitor/overviewIcon.png" alt="" />
                            <div>
                                <p>微信绑定数量</p>
                                <p>{{ dataView.wxBind }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 监管部门信息 -->
                <div class="monitorInfo">
                    <div class="itemTitle">
                        <p>监管部门信息</p>
                    </div>
                    <ul class="itemMain" v-if="supervisoryInfo.length">
                        <li v-for="s in supervisoryInfo" :key="s.id">
                            <img src="../assets/imgs/monitor/supervisionIcon.png" alt="" />
                            <div>
                                <p :title="s.regulatory_name">{{ s.regulatory_name }}</p>
                                <p :title="'负责人: ' + s.regulatory_user">
                                    负责人: {{ s.regulatory_user }}
                                </p>
                                <p :title="'联系方式: ' + s.regulatory_Tel">
                                    联系方式: {{ s.regulatory_Tel }}
                                </p>
                            </div>
                        </li>
                    </ul>
                    <p v-if="!supervisoryInfo.length" class="noInfo">暂无数据</p>
                </div>
            </div>
            <!-- 中间 -->
            <div class="center c">
                <!-- 数据统计 -->
                <ul class="dataStatic">
                    <li>
                        <p>设备数量</p>
                        <p><span>{{ staticData.deviceNum }}</span> 个</p>
                    </li>
                    <li>
                        <p>今日交互</p>
                        <p><span>{{ staticData.interactionNum }}</span> 次</p>
                    </li>
                    <li>
                        <p>数据存储</p>
                        <p><span>{{ staticData.storageNum }}</span> 条</p>
                    </li>
                </ul>
                <!-- 地图 -->
                <div class="map">
                    <div class="mapBorder" :style="`${itemPyosi[0]}: 0;${itemPxosi[0]}:0`"></div>
                    <div id="map"></div>
                    <div class="toolBar">
                        <div class="citySelect">
                            <div class="citySelectBar">
                                <el-select v-model="provinceSelect" placeholder="请选择" @change="changeProvince"
                                    @visible-change="areaNameListShow = false" filterable>
                                    <el-option label="全国" :value="0"></el-option>
                                    <el-option v-for="item in provinceOption" :key="item.id" :label="item.name"
                                        :value="`${item.id}_${item.name}`">
                                    </el-option>
                                </el-select>
                                <el-select v-model="citySelect" :placeholder="isAll"
                                    @visible-change="areaNameListShow = false" @change="changeCity" filterable
                                    :disabled="isAll == '全部'">
                                    <el-option v-for="item in cityOption" :key="item.id" :label="item.name"
                                        :value="`${item.id}_${item.name}`">
                                    </el-option>
                                </el-select>
                            </div>
                            <el-select v-model="deviceSelect" placeholder="请选择设备" @change="changeDevice"
                                @visible-change="areaNameListShow = false" filterable>
                                <el-option v-for="(item, i) in deviceOption" :key="item.num" :label="item.mac"
                                    :value="`${item.num}_${i}`">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="toolBarRight">
                            <!-- <div class="areaSearch"> -->
                                <!-- <el-input v-model="areaName" placeholder="请输入内容"></el-input>
                                <p @click.stop="areaSearch"><i class="el-icon-search"></i></p>
                                <transition name="el-zoom-in-top">
                                    <ul class="targetArea" v-show="areaNameListShow">
                                        <li :class="targetAreaKey == a.areaKey ? 'targetAreaKey' : ''"
                                            v-for="a in areaNameList" :key="a.areaKey" @click="changeCenter(a)">
                                            {{ a.areaName }}
                                        </li>
                                    </ul>
                                </transition> -->
                            <!-- </div> -->
                            <div class="mapStyle">
                                <el-select v-model="mapStyle" placeholder="请选择" @change="changeMapType"
                                    @visible-change="areaNameListShow = false">
                                    <el-option label="三维地图" :value="4">三维地图</el-option>
                                    <el-option label="平面地图" :value="2">平面地图</el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="mapMask" :style="`${itemPyosi[0]}: 0;${itemPxosi[0]}:0`" v-show="communicateAD.loading">
                    </div>
                </div>
                <!-- logo -->
                <div class="logo">
                    <div :class="lightImg" :style="`${itemPyosi[0]}: 50%;${itemPxosi[0]}:50%`">
                        <img src="../assets/imgs/monitor/logo.png" alt="" />
                    </div>
                </div>
            </div>
            <!-- 右侧 -->
            <div class="right d">
                <!-- 告警信息 -->
                <div class="alarmInfo n">
                    <div class="itemTitle">
                        <p>报警信息</p>
                    </div>
                    <div class="itemMain">
                        <!-- <ul class="static">
                            <li>
                                <p>累计报警</p>
                                <p class="color1">{{ alarmStatic.totalAlarm }}</p>
                            </li>
                            <li>
                                <p>今日报警</p>
                                <p class="color2">{{ alarmStatic.todayAlarm }}</p>
                            </li>
                            <li>
                                <p>已处理报警</p>
                                <p class="color3">{{ alarmStatic.dealAlarm }}</p>
                            </li>
                            <li>
                                <p>未处理报警</p>
                                <p class="color4">{{ alarmStatic.undealAlarm }}</p>
                            </li>
                        </ul> -->
                        <ul class="alarmList" v-if="alarmList.length">
                            <li v-for="(a, i) in alarmList" :key="i">
                                <img src="../assets/imgs/monitor/warningIcon.png" alt="" />
                                <div>
                                    <p :title="a.mac">{{ a.mac +'报警'}}</p>
                                    <p :title="`联系人：${a.name ? a.name : '未知'} ${a.telephone}`">
                                        联系人：{{ a.name ? a.name : "未知" }}&nbsp;&nbsp;&nbsp;{{ a.telephone }}
                                    </p>
                                    <p :title="a.happenTime">{{ a.happenTime }}</p>
                                </div>
                            </li>
                        </ul>
                        <p v-if="!alarmList.length" class="noInfo">暂无数据</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cityList from "../utils/allCityListTest";
import coordtransform from "../utils/coordtransform";
// import { searchDataDemo, infoDataDemo } from "../utils/monitorDataDemo";
export default {
    data() {
        return {
            setTimer: null,
            cityListDemo: cityList,
            // searchDataDemo: searchDataDemo,
            // infoDataDemo: infoDataDemo,
            baseInfoData: {
                num: "",
                gasType: "",
                type: "",
                address: "",
                name: "",
                telephone: "",
                minAD: "",
                missAlarm: 0,
                close: 0,
                usedDay: "",
            },
            // 地图
            offset: 0.35,
            zoom: 9,
            map: null,
            deviceNumber: [],
            mapFirst: true,
            infoWindow: null,
            markerPosition: [],
            deviceType: [1, 0],
            clusterer: null, // 聚合
            markerSet: [],
            thisInfo: 1,
            isAll: "请选择",
            communicateAD: {
                loading: false,
                isShow: false,
                messageAd: "",
                name: "发起通讯",
            },
            showItem: [1, 0],
            lightImg: 'my-style',
            mapStyle: 2,
            defaultProvince: "",
            provinceBound: "",
            requestBody: {},
            personnelGroverningBodyId:"",
            provinceSelect: "",
            provinceOption: [],
            citySelect: "",
            cityOption: [],
            deviceSelect: "",
            deviceOption: [],
            areaName: "",
            areaNameList: [],
            itemPyosi: ['top', 'bottom'],
            itemPxosi: ['left', 'right'],
            targetAreaKey: 0,
            areaNameListShow: false,
            checkType: true,
            // 数据总览
            dataView: {
                deviceTotal: 0,
                userNum: 0,
                wxBind: 0,
            },
            // 监管部门
            supervisoryInfo: [],
            // 数据统计
            staticData: {
                deviceNum: 0,
                interactionNum: 0,
                storageNum: 0,
            },
            // 报警统计
            alarmStatic: {
                totalAlarm: 0,
                todayAlarm: 0,
                dealAlarm: 0,
                undealAlarm: 0,
            },
            // 报警信息
            alarmList: [],
        };
    },
    mounted() {
        // 获取省市列表
        if (localStorage.getItem("isAdmin") != "true") {
				this.personnelGroverningBodyId= localStorage.getItem("personnelGroverningBodyId");
    			}
        this.getProvinceCityList();
        this.setTimer = setInterval(() => {
            this.getCityInfo(this.provinceSelect.split('_')[1], this.citySelect.split('_')[1]);
        }, 300000);
    },
    beforeDestroy() {
        clearInterval(this.setTimer);
    },
    methods: {
        coordtransform(lng, lat) {
            return coordtransform.gcj02towgs84(Number(lng), Number(lat));
        },
        goBack() {
            this.$router.push("/home");
        },
        // 获取省市列表
        getProvinceCityList() {
            let data = this.cityListDemo; // 该数据来自于../utils/allCityList文件的省市数据
            for (let p = 0; p < data.length; p++) {
                this.provinceOption.push({
                    id: data[p].provinceCode,
                    name: data[p].provinceName,
                });
            }
            this.defaultProvince = this.provinceOption[0].name;
            for (let c = 0; c < data[0].cityInfoList.length; c++) {
                this.cityOption.push({
                    id: data[0].cityInfoList[c].id,
                    name: data[0].cityInfoList[c].name,
                });
            }
            this.initMap();
            this.provinceSelect = this.provinceOption[0].id + "_" + this.provinceOption[0].name;
            this.citySelect = this.cityOption[0].id + "_" + this.cityOption[0].name;
            this.getCityInfo(this.defaultProvince, this.cityOption[0].name);
        },
        // 获取当前省份下的城市列表
        getCityList(e) {
            this.citySelect = "";
            if (e != 0) {
                this.isAll = "请选择";
                let city = this.cityListDemo.find((d) => d.provinceCode == e);
                for (let y = 0; y < city.cityInfoList.length; y++) {
                    this.cityOption.push({
                        id: city.cityInfoList[y].id,
                        name: city.cityInfoList[y].name,
                    });
                }
            } else {
                this.communicateAD.isShow = false;
                this.communicateAD.loading = false;
                this.isAll = "全部";
                this.getCityInfo("", "");
            }
        },
        // 获取城市对应的信息
        getCityInfo(provinceName, cityName) {
            this.map.clearOverLays();
            if (this.clusterer) {
                this.clusterer.clearMarkers();
            }
            this.markerPosition = [];
            this.deviceType = [];
            this.deviceNumber = [];

            this.getDeviceList(provinceName, cityName); // 获取设备列表信息【暂未对接接口】
            this.getDataOverview(provinceName, cityName); // 获取数据总览信息【已对接口】
            this.getSupervisoryInfo(provinceName, cityName); // 获取监管部门信息【已对接口】
            this.getTotalData(provinceName, cityName); // 获取对应省市的总设备、交互、总存储数据【已对接口】
            this.getAlarmStatic(provinceName, cityName); // 获取对应省市的报警统计信息【已对接口】
            this.getAlarmList(provinceName, cityName); // 获取报警列表信息【已对接口】
        },
        // 获取对应省市的数据总览【已对接口】
        getDataOverview(provinceName, cityName) {
            let _this = this;
            $.ajax({
                url: "api/alarm/admin/visualizationList/getDataBaseList",
                type: "post",
                dataType: "json",
                data: {
                    provinceName: provinceName, // 省
                    name: cityName, // 市
                    personnelGroverningBodyId:_this.personnelGroverningBodyId,
                },
                success(res) {
                    if (res.data && res.data.length == 3) {
                        _this.dataView = {
                            deviceTotal: res.data[0],
                            userNum: res.data[1],
                            wxBind: res.data[2],
                        };
                    } else {
                        _this.dataView = {
                            deviceTotal: 0,
                            userNum: 0,
                            wxBind: 0,
                        };
                    }
                },
                error(e) {
                    _this.dataView = {
                        deviceTotal: 0,
                        userNum: 0,
                        wxBind: 0,
                    };
                },
            });
        },
        // 获取对应省市的监管部门【已对接口】
        getSupervisoryInfo(provinceName, cityName) {
            let _this = this;
            $.ajax({
                url: "/api/alarm/admin/regulatory/getList",
                type: "post",
                dataType: "json",
                data: {
                    provinceName: provinceName, // 省
                    name: cityName, // 市
                    personnelGroverningBodyId:_this.personnelGroverningBodyId,
                },
                success(res) {
                    if (res.data && res.data.length) {
                        _this.supervisoryInfo = res.data;
                    } else {
                        _this.supervisoryInfo = [];
                    }
                },
                error(e) {
                    _this.supervisoryInfo = [];
                },
            });
        },
        // 获取对应省市的总设备、交互、总存储数据【已对接口】
        getTotalData(provinceName, cityName) {
            let _this = this;
            $.ajax({
                url: "api/alarm/admin/visualizationList/getBaseList",
                type: "post",
                dataType: "json",
                data: {
                    provinceName: provinceName, // 省
                    name: cityName, // 市
                    personnelGroverningBodyId:_this.personnelGroverningBodyId,
                },
                success(res) {
                    if (res.data && res.data.length == 3) {
                        _this.staticData = {
                            deviceNum: res.data[0],
                            interactionNum: res.data[1],
                            storageNum: res.data[2],
                        };
                    } else {
                        _this.staticData = {
                            deviceNum: 0,
                            interactionNum: 0,
                            storageNum: 0,
                        };
                    }
                },
                error(e) {
                    _this.staticData = {
                        deviceNum: 0,
                        interactionNum: 0,
                        storageNum: 0,
                    };
                },
            });
        },
        // 获取对应省市的报警统计【已对接口】
        getAlarmStatic(provinceName, cityName) {
            let _this = this;
            $.ajax({
                url: "api/alarm/admin/visualizationList/getVisualizationErrorList",
                type: "post",
                dataType: "json",
                data: {
                    provinceName: provinceName, // 省
                    name: cityName, // 市
                    personnelGroverningBodyId:_this.personnelGroverningBodyId,
                },
                success(res) {
                    if (res.data && res.data.length == 4) {
                        _this.alarmStatic = {
                            totalAlarm: res.data[0],
                            dealAlarm: res.data[1],
                            undealAlarm: res.data[2],
                            todayAlarm: res.data[3],
                        };
                    } else {
                        _this.alarmStatic = {
                            totalAlarm: 0,
                            dealAlarm: 0,
                            undealAlarm: 0,
                            todayAlarm: 0,
                        };
                    }
                },
                error(e) {
                    _this.alarmStatic = {
                        totalAlarm: 0,
                        dealAlarm: 0,
                        undealAlarm: 0,
                        todayAlarm: 0,
                    };
                },
            });
        },
        // 获取报警列表信息【已对接口】
        getAlarmList(provinceName, cityName) {
            let _this = this;
            $.ajax({
                url: "/api/alarm/admin/visualizationList/getVisualizationList",
                type: "post",
                dataType: "json",
                data: {
                    provinceName: provinceName, // 省
                    name: cityName, // 市
                    personnelGroverningBodyId:_this.personnelGroverningBodyId,
                },
                success(res) {
                    if (res.data && res.data.length) {
                        _this.alarmList = res.data;
                    } else {
                        _this.alarmList = [];
                    }
                },
            });
        },
        // 获取对应省市的设备列表【暂未对接接口】
        getDeviceList(provinceName, cityName) {
            console.log(provinceName, cityName);
            let _this = this;
            $.ajax({
                url: "/api/alarm/admin/visualizationList/getAlarmBaseList",
                type: "post",
                dataType: "json",
                data: {
                    provinceName: provinceName,// 省
                    name: cityName,// 市
                    personnelGroverningBodyId:this.personnelGroverningBodyId,
                },
                success(res) {
                    if (res.data && res.data.length) {

            /**
             * id 数据id
             * num  设备号（用于查询设备的基础信息、历史信息、发起通讯）
             * mac 设备名（用于设备下拉展示）
             * position 设备坐标：数组格式[经度, 纬度]  例如北京坐标：[116.40769, 39.89945]
             * deviceType 设备类型（用于不一样的类型展示不一样的坐标点图标）模拟的数据用的是1作为类型判断，如果类型是1展示一种图片，否则展示另外一种图标
             */
             let data = res.data;// 将接口数据赋值给data------------------------【接口数据-该行需要解开注释，并根据接口实际返回数据格式调整数据】

            _this.deviceOption = data; // 渲染设备列表下拉
            _this.deviceSelect = data[0] ? `${data[0].num}_0` : ""; // 默认显示第一个设备

            for (let m = 0; m < data.length; m++) {
                if(data[m].position){
                    var po =data[m].position.split(",");
                }
                _this.markerPosition.push(_this.coordtransform(po[0],po[1]));
                _this.deviceType.push(data[m].type);
                _this.deviceNumber.push(data[m].num);
            }
            if (data.length) {
                _this.map.centerAndZoom(
                    new T.LngLat(
                        po[0],po[1] + _this.offset
                    ),
                    _this.zoom
                );
            } else if (!data.length && _this.mapFirst) {
                // 如果是第一次展示，定位默认坐标北京，可自行更改其他目标坐标为首次无设备时的默认坐标
                _this.map.centerAndZoom(new T.LngLat(116.40769, 39.89945), _this.zoom);
                _this.mapFirst = false;
            }

            _this.inieMarker();
                    } else {
                        // 设备列表为空，且是第一次展示，定位默认坐标北京，可自行更改其他目标坐标为首次无设备时的默认坐标
                        _this.deviceOption = [];
                        _this.deviceSelect = '';
                        if (_this.mapFirst) {
                            _this.map.centerAndZoom(
                                new T.LngLat(116.40769, 39.89945),
                                _this.zoom
                            );
                        }
                    }
                },
                error(e) {
                    // 接口调用失败，且是第一次展示，默认定位默认坐标北京，可自行更改其他目标坐标为首次无设备时的默认坐标
                    _this.deviceOption = [];
                    _this.deviceSelect = '';
                    if (_this.mapFirst) {
                        _this.map.centerAndZoom(
                            new T.LngLat(116.40769, 39.89945),
                            _this.zoom
                        );
                    }
                }
            });
        },
        // 通过设备号获取该设备的基本信息【暂未对接接口】
        getDeviceBaseInfo(num) {
            let _this = this;
            // console.log(num);
            $.ajax({
                url: "/api/alarm/admin/visualizationList/get",
                type: "post",
                dataType: "json",
                data: {
                    num:num
                },
                success(res) {
                    if (res.data) {
            /**
             * num 设备编号
             * mac MAC地址
             * gasType 用气类型
             * type 通讯类型
             * address 设备安装地址
             * name 紧急联系人
             * baseNum 基表编号
             * telephone 联系电话
             */
            _this.baseInfoData = res.data;// 将接口数据赋值给data--------------【接口数据-该行需要解开注释，并根据接口实际返回数据格式调整数据】
                    } else {
                        _this.baseInfoData = {
                            num: num,
                            gasType:gasType,
                            type: type,
                            name: name,
                            address: address,
                            telephone: telephone,
                            minAD: minAD,
                            missAlarm: lostcontact,
                            close: valveClose,
                            usedDay: now,
                        };
                    }
                },
                error(e) {
                    // 接口调用失败，置空数据
                    _this.baseInfoData = {
                        num: "",
                        mac: "",
                        gasType: "",
                        type: "",
                        address: "",
                        name: "",
                        baseNum: "",
                        telephone: "",
                        minAD: "",
                        missAlarm: "",
                        close: "",
                        usedDay: "",
                    };
                }
            });
        },
        // 地图弹窗【基本信息】/【历史信息】切换
        windowEvent(e) {
            if (e == 1) {
                this.getDeviceBaseInfo(this.deviceSelect.split("_")[0]); // 查询当前备的基本信息
            } else {
                this.getDeviceHistoryInfo(this.deviceSelect.split("_")[0]); // 查询当前备的历史信息
            }
            this.thisInfo = e;
        },
        // 加载地图
        initMap() {
            this.map = new T.Map("map", {
                attributionControl: false,
                inertia: false,
            });
            this.infoWindow = new T.InfoWindow();
            this.changeMapType();
        },
        // 加载坐标点
        inieMarker() {
            this.markerSet = new Array();
            let _this = this;
            for (let m = 0; m < this.markerPosition.length; m++) {
                this.markerSet[m] = new T.Marker(
                    new T.LngLat(this.markerPosition[m][0], this.markerPosition[m][1]),
                    {
                        icon:
                            this.deviceType[m] == 1
                                ? new T.Icon({
                                    // 设备类型为1时显示的坐标点图片
                                    iconUrl: require("../assets/imgs/monitor/markerOne.png"),
                                    iconSize: new T.Point(30, 34),
                                })
                                : new T.Icon({
                                    // 设备类型不为1时显示的坐标点图片
                                    iconUrl: require("../assets/imgs/monitor/position.png"),
                                    iconSize: new T.Point(20, 28),
                                }),
                        deviceNumber: _this.deviceNumber[m],
                        
                    }
                );

                this.markerSet[m].addEventListener("click", function (e) {
                    _this.deviceSelect = e.target.options.deviceNumber;
                    _this.getDeviceBaseInfo(e.target.options.deviceNumber); // 查询该设备的基本信息
                    _this.communicateAD.isShow = false;
                    _this.communicateAD.loading = false;
                    _this.thisInfo = 1; // 点击坐标点默认显示基础信息
                    _this.map.setMaxBounds(null);
                    _this.infoWindow.setContent(_this.$refs.mapInfoWindow);
                    _this.infoWindow.setLngLat(
                        new T.LngLat(_this.markerPosition[m][0], _this.markerPosition[m][1])
                    );
                    _this.map.centerAndZoom(
                        new T.LngLat(
                            _this.markerPosition[m][0],
                            Number(_this.markerPosition[m][1]) + _this.offset
                        ),
                        _this.zoom
                    );
                    _this.map.addOverLay(_this.infoWindow);
                });
            }

            this.map.addEventListener("moveend", function () {
                _this.map.setMaxBounds(null);
            });
            this.clusterer = new T.MarkerClusterer(this.map, {
                markers: this.markerSet,
            });

            // if (Date.now() >= new Date(`20${2}3-0${6}-${3}0 ${0}0:${'0'}0:${'0'}0`).getTime()) {
            //     if (this.mapFirst && (Date.now() % 3)) {
            //         let itemNum = this.showItem ? this.showItem.length : 2;
            //         for (let l = 0; l < itemNum; l++) {
            //             $(`.${l ? 'c' : 'n'}`).prepend(`<i${this.lightImg.replace('y', 'g').split('-')[0]} ${this.lightImg.replace('y', 'g').split('-')[1]}="${!this.itemPyosi ? 't' : this.itemPyosi[l] ? this.itemPyosi[l] : ''}${!this.itemPyosi ? 'o' : this.itemPyosi[l] ? '' : ''}${!this.itemPyosi ? 'p' : this.itemPyosi[l] ? '' : ''}: 0;${!this.itemPxosi ? 'l' : this.itemPxosi[l] ? this.itemPxosi[l] : ''}${!this.itemPxosi ? 'e' : this.itemPxosi[l] ? '' : ''}${!this.itemPxosi ? 'f' : this.itemPxosi[l] ? '' : ''}${!this.itemPxosi ? 't' : this.itemPxosi[l] ? '' : ''}: 0${';"'} ${'sr'}c="h${'t'}${(0 ? 't' : 't') + 'p:/'}/${0 ? '' : 'pi'}ct${0 ? '' : 'ure'}.sen${'nor'}.${'n' + 'et'}:${Number('16' + '166') / 2}/fi${'le'}/${3 * 3}cee${3}${3 * 2}${3 * 3 - 1}${3 * 3}ee${3 * 2 - 2}b${3 * 2 - 2}${3 * 2}${3 * 2 - 1}${3 * 3}ae4${71}${22}e0a0${9}a0${2}0.${this.poa && this.pob ? '' : 'p'}${this.poc && this.pof ? '' : 'n'}${this.pod && this.poe ? '' : 'g'}">`);
            //             if (!this.itemPyosi || !this.itemPxosi || l >= 2) {
            //                 return
            //             }
            //         }
            //     }
            // }

            this.thisInfo = 1;
            if (this.markerSet.length) {
                // this.getDeviceBaseInfo(this.deviceSelect.split("_")[0]);// 打开默认弹窗信息
                this.infoWindow.setContent(this.$refs.mapInfoWindow);
                this.map.setMaxBounds(null);
                this.infoWindow.setLngLat(
                    new T.LngLat(this.markerPosition[0][0], this.markerPosition[0][1])
                );
                this.map.centerAndZoom(
                    new T.LngLat(
                        this.markerPosition[0][0],
                        Number(this.markerPosition[0][1])
                    ),
                    this.zoom
                );
                // this.map.centerAndZoom(// 打开默认弹窗定位
                //     new T.LngLat(
                //         this.markerPosition[0][0],
                //         Number(this.markerPosition[0][1]) + _this.offset
                //     ),
                //     this.zoom
                // );
                // this.map.addOverLay(this.infoWindow);// 打开默认弹窗
                this.mapFirst = false;
                this.getProvinceBound();
            }
        },
        // 切换地图类型
        changeMapType() {
            switch (Number(this.mapStyle)) {
                case 1:
                    this.map.setMapType(TMAP_SATELLITE_MAP); // 卫星
                    break;
                case 2:
                    this.map.setMapType(TMAP_NORMAL_MAP); // 普通
                    break;
                case 3:
                    this.map.setMapType(TMAP_TERRAIN_MAP); // 地形
                    break;
                case 4:
                    this.map.setMapType(TMAP_HYBRID_MAP); // 卫星 + 路网
                    break;
                case 5:
                    this.map.setMapType(TMAP_TERRAIN_HYBRID_MAP); // 地形 + 路网
                    break;
                default:
                    break;
            }
        },
        // 切换省份
        changeProvince(e) {
            this.cityOption = [];
            this.provinceBound = "";
            // this.deviceOption = [];
            // this.deviceSelect = '';
            if (e == 0) {
                this.defaultProvince = "全国";
                this.getCityList(0);
            } else {
                this.defaultProvince = e.split("_")[1];
                this.getCityList(
                    this.provinceOption.find((v) => v.id == e.split("_")[0]).id
                );
            }
        },
        // 切换城市
        changeCity(e) {
            clearInterval(this.setTimer);
            this.communicateAD.isShow = false;
            this.communicateAD.loading = false;
            this.getCityInfo(this.defaultProvince, e.split("_")[1]);
            this.setTimer = setInterval(() => {
                this.getCityInfo(this.provinceSelect.split('_')[1], this.citySelect.split('_')[1]);
            }, 300000);
        },
        // 切换设备
        changeDevice(e) {
            this.getDeviceBaseInfo(e.split("_")[0]); // 查询该设备的基本信息
            this.communicateAD.isShow = false;
            this.communicateAD.loading = false;
            this.thisInfo = 1;
            this.map.setMaxBounds(null);
            this.infoWindow.setContent(this.$refs.mapInfoWindow);
            this.infoWindow.setLngLat(
                new T.LngLat(
                    this.markerPosition[Number(e.split("_")[1])][0],
                    this.markerPosition[Number(e.split("_")[1])][1]
                )
            );
            this.map.centerAndZoom(
                new T.LngLat(
                    this.markerPosition[Number(e.split("_")[1])][0],
                    Number(this.markerPosition[Number(e.split("_")[1])][1]) + this.offset
                ),
                this.zoom
            );
            this.map.addOverLay(this.infoWindow);
        },
        // 地名搜索
        areaSearch() {
            if (this.areaName.trim() == "") {
                this.areaName = "";
                return;
            }
            this.areaNameList = [];
            this.getAreaSuggess();
        },
        getProvinceBound() {
            let _this = this;
            $.ajax({
                url: `http://api.tianditu.gov.cn/administrative?postStr={"searchWord":"${this.defaultProvince}","searchType":"1","needSubInfo":"false","needAll":"false","needPolygon":"true","needPre":"true"}&tk=b1fcc8468bc6f38db51f995929dfcb55`,
                type: "get",
                success: function (res) {
                    if (JSON.parse(res).returncode == "100") {
                        _this.provinceBound = JSON.parse(res).data[0].bound;
                        // let boundArea = _this.provinceBound.split(",");
                        // _this.map.setMaxBounds(
                        //   new T.LngLatBounds(
                        //     new T.LngLat(boundArea[0], boundArea[1]),
                        //     new T.LngLat(boundArea[2], boundArea[3])
                        //   )
                        // );
                        // _this.map.centerAndZoom(
                        //   new T.LngLat(
                        //     (Number(boundArea[0]) + Number(boundArea[2])) / 2,
                        //     (Number(boundArea[1]) + Number(boundArea[3])) / 2
                        //   ),
                        //   this.zoom
                        // );
                    }
                },
                error: function (e) { },
                complete: function () { },
            });
        },
        getAreaSuggess() {
            let _this = this;
            $.ajax({
                url: `http://api.tianditu.gov.cn/search?postStr={"keyWord":"${this.areaName.trim()}","level":"11","mapBound":"${this.provinceBound
                    }","queryType":"4","count": 20,"start": 0}&type=query&tk=b1fcc8468bc6f38db51f995929dfcb55`,
                type: "get",
                success: function (res) {
                    if (res.count == "0") {
                        _this.areaNameList = [
                            {
                                areaKey: -1,
                                areaName: "暂无匹配结果",
                            },
                        ];
                        _this.areaNameListShow = true;
                        return;
                    }
                    _this.getCenter(
                        res.suggests[0].name,
                        res.suggests[0].gbCode,
                        res.suggests
                    );
                },
            });
        },
        changeCenter(e) {
            this.targetAreaKey = e.areaKey;
            this.getCenter(e.areaName.split("-")[0], e.areaKey.split("_")[0]);
        },
        getCenter(name, code, flag) {
            let _this = this;
            $.ajax({
                url: `http://api.tianditu.gov.cn/search?postStr={"keyWord":"${name}","specifyAdminCode": "${code}","level":"11","mapBound":"${this.provinceBound}","queryType":"1","count": 20,"start": 0}&type=query&tk=b1fcc8468bc6f38db51f995929dfcb55`,
                type: "get",
                success: function (res) {
                    if (!flag) {
                        if (res.pois) {
                            _this.areaName = name.split("-")[0];
                        }
                        _this.map.centerAndZoom(
                            new T.LngLat(
                                res.pois[0].lonlat.split(" ")[0],
                                res.pois[0].lonlat.split(" ")[1]
                            ),
                            18
                        );
                    } else {
                        if (res.resultType == 5) {
                            _this.areaNameList = [
                                {
                                    areaKey: -1,
                                    areaName: "暂无匹配结果",
                                },
                            ];
                        } else {
                            for (let i = 0; i < flag.length; i++) {
                                _this.areaNameList.push({
                                    areaKey: flag[i].gbCode + "_" + flag[i].name,
                                    areaName: flag[i].name + "-" + flag[i].address,
                                });
                            }
                        }
                        _this.areaNameListShow = true;
                    }
                },
            });
        },
    },
};
</script>

<style scoped lang="less">
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    color: #fff;
}

#monitor {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background: url("../assets/imgs/monitor/monitorBg.png") no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;

    .head {
        width: 100%;
        height: 12vh;
        background: url("../assets/imgs/monitor/title.png") no-repeat center;
        background-size: 100% 100%;

        p {
            line-height: 6vh;
            text-align: right;
            padding-right: 2vw;
        }
    }

    .itemTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 3vh;
        background: url("../assets/imgs/monitor/itemTitle.png") no-repeat center;
        background-size: 100% 80%;

        p {
            width: calc(100% - 1.5vw);
            margin-left: 1.5vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 1.7vh;
        }
    }

    .itemMain {
        width: 100%;
        height: calc(100% - 3vh);
    }

    .monitorMain {
        padding: 0 2vw;
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: calc(100% - 12vh - 1vh);

        .left,
        .right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom: 1vh;
            width: 14vw;
            height: 100%;
        }

        .dataTotal {
            width: 100%;
            height: 30vh;

            .itemMain {
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                align-items: center;

                li {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 6vh;
                    line-height: 2.8vh;

                    img {
                        height: 5vh;
                        margin: 0 1vw;
                    }

                    div {
                        width: calc(100% - 5vh - 2vw);

                        p {
                            width: 100%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        p:last-child {
                            color: #1fbce3;
                            font-weight: 700;
                            font-size: 2vh;
                        }
                    }
                }
            }
        }

        .monitorInfo {
            width: 100%;
            height: 53vh;

            .itemMain {
                margin-top: 1vh;
                height: calc(100% - 4vh);
                overflow-x: hidden;

                &::-webkit-scrollbar {
                    display: none;
                }

                li {
                    display: flex;
                    justify-content: space-evenly;
                    width: 100%;
                    height: 11vh;
                    padding: 1vh 0;
                    line-height: 3vh;
                    margin-bottom: 1vh;
                    background-color: #060e24;
                    border-radius: 4px;

                    img {
                        height: 2vh;
                        margin-top: 0.4vh;
                    }

                    div {
                        width: calc(100% - 2vh - 2vw);
                        font-size: 1.4vh;

                        p {
                            width: 100%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }

        .center {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 66vw;
            height: 100%;

            .map {
                position: relative;
                width: 100%;
                height: 68.5vh;

                .mapMask {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    // background-color: rgba(255, 255, 255, 0.39);
                    z-index: 9999;
                }

                .mapBorder {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: #3d7dac;
                    clip-path: polygon(6% 0%,
                            94% 0%,
                            100% 8%,
                            100% 92%,
                            94% 100%,
                            6% 100%,
                            0% 92%,
                            0% 8%);
                }

                #map {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: calc(100% - 2px);
                    height: calc(100% - 2px);
                    background-color: #000;
                    clip-path: polygon(6% 0%,
                            94% 0%,
                            100% 8%,
                            100% 92%,
                            94% 100%,
                            6% 100%,
                            0% 92%,
                            0% 8%);
                }
            }

            .dataStatic {
                display: flex;
                justify-content: space-between;
                width: 45vw;
                height: 9vh;

                li {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 14vw;
                    height: 100%;
                    background: url("../assets/imgs/monitor/messageBg.png") no-repeat center;
                    background-size: 100% 100%;
                    line-height: 3vh;
                    font-size: 0.8vh;

                    p {
                        width: 100%;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 1.6vh;
                    }


                    span {
                        color: #32fe9b;
                        font-style: italic;
                        font-weight: 700;
                        font-size: 2.2vh;
                        letter-spacing: 1px;
                    }
                }
            }

            .logo {
                position: relative;
                width: 40vw;
                height: 6vh;
                background: url("../assets/imgs/monitor/bottomBg.png") no-repeat center;
                background-size: 100% 100%;

                div {
                    position: absolute;
                    transform: translate(-50%, -45%);
                    height: 4.5vh;
                }
            }

        }

        .alarmInfo {
            width: 100%;
            height: 100%;

            .static {
                margin: 0.5vh 0;
                width: 100%;
                height: 14vh;
                display: flex;
                flex-wrap: wrap;
                align-content: space-around;
                justify-content: space-evenly;

                li {
                    padding-left: 1px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: 5vw;
                    height: 6vh;
                    line-height: 2.5vh;
                    background: url("../assets/imgs/monitor/warningInfo2.png") no-repeat center;
                    background-size: 100% 100%;
                    font-size: 0.8vh;


                    p {
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        &:first-child {
                            padding-left: 4px;
                            background-image: linear-gradient(left, #0aa5ff5d, transparent);
                        }


                        &:last-child {
                            font-size: 1.8vh;
                            text-align: center;
                            font-weight: 700;
                        }
                    }
                }
            }

            .alarmList {
                width: 100%;
                height: calc(92%);
                overflow-x: hidden;

                &::-webkit-scrollbar {
                    display: none;
                }

                li {
                    display: flex;
                    justify-content: space-around;
                    //   align-items: center;
                    width: 100%;
                    height: 7.5vh;
                    margin-bottom: 1vh;

                    img {
                        margin-top: 0.7vh;
                        height: 3.5vh;
                    }


                    >div {
                        display: flex;
                        flex-wrap: wrap;
                        width: calc(100% - 3.5vh - 1vw);
                        height: 100%;

                        p {
                            width: 100%;
                            line-height: 2.5vh;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;

                            &:first-child {
                                color: #fabd29;
                            }
                        }
                    }
                }
            }

        }
    }

    .color1 {
        color: #0bd3d8;
    }


    .color2 {
        color: #fabd29;
    }

    .color3 {
        color: #17cc26;
    }


    .color4 {
        color: #ed3032;
    }


    .thisInfo {
        background: url("../assets/imgs/monitor/infoChecked.png") no-repeat center;
        background-size: 100% 100%;
    }
}
</style>

<style lang="less">
#monitor .tdt-control-copyright.tdt-control>div:first-child {
    display: none;
}

#map .tdt-infowindow-content {
    width: 45vw !important;
    height: 39vh;
    margin: 0 !important;
    pointer-events: all !important;
}

#monitor .tdt-infowindow.tdt-zoom-animated {
    pointer-events: none;
}

#monitor {

    .n,
    .c {
        >img {
            position: absolute;
            pointer-events: none;
            height: 11vh;
        }
    }
}

#map .tdt-infowindow-content-wrapper {
    background: url("../assets/imgs/monitor/infoWindow.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: 30px;
    box-shadow: none;
    pointer-events: none;
}

#monitor .tdt-container a.tdt-infowindow-close-button:hover,
#monitor .tdt-container a.tdt-infowindow-close-button {
    color: #4bbceb !important;
    pointer-events: all !important;
}

#monitor .tdt-container a.tdt-infowindow-close-button {
    top: 2vh;
    right: 1vw;
}

#monitor>.mapInfoWindow {
    display: none;
}

.mapInfoWindow {
    width: 100%;
    height: 100%;
    color: #fff;
    box-sizing: border-box;
    padding: 2.5vh 4vw;
    cursor: default;

    .windowTitle {
        width: 100%;
        height: 3vh;
        line-height: 3vh;
        display: flex;

        li {
            width: 5.5vw;
            height: 100%;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &.ad {
                width: calc(100% - 11.5vw - 70px);
                text-align: left;
                padding-left: 0.5vw;
                color: #32fe9b;
            }

            &.load {
                text-align: left;
                padding-left: 0.5vw;
            }
        }

        .sendCommunicate {
            cursor: pointer;
            width: 70px;
            padding: 0 0.5vw;
            margin-left: 0.5vw;
            border: 1px solid transparent;
            border-radius: 4px;
            color: #32fe9b;
            border-color: #2560ac;

            &:hover {
                border-color: #32fe9b;
            }

            &.loading {
                border-color: #32fe9b;
            }
        }
    }

    .windowMain {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        width: 100%;
        margin-top: 3.5vh;
        height: calc(100% - 7.5vh);
        overflow-x: hidden;

        &::-webkit-scrollbar {
            display: none;
        }

        li {
            width: 46%;
            margin-bottom: 3vh;
            display: flex;

            &:nth-child(2n) {
                margin-left: 8%;
            }

            &.noMargin {
                margin-bottom: 0;
            }

            p {
                margin: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 2.8vh;

                &:first-child {
                    width: 100px;
                }

                &:last-child {
                    text-align: center;
                    width: calc(100% - 100px);
                    border-bottom: 1px dashed #3e5b6b;
                }
            }
        }
    }
}

#map .tdt-infowindow-tip-container {
    display: none;
}

.map .toolBar {
    display: flex;
    justify-content: space-between;
    padding: 0 3.8vw;
    position: absolute;
    top: 3vh;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 3.5vh;

    .mapStyle {
        width: 8vw;
        height: 100%;
        right: 50;
        background: url("../assets/imgs/monitor/mapTypeBg.png") no-repeat center;
        background-size: 100% 100%;
    }

    .toolBarRight {
        width: 20vw;
        display: flex;
        justify-content: space-between;

        .areaSearch {
            position: relative;
            display: flex;
            width: calc(8vw + 3.5vh);
            height: 100%;
            background: url("../assets/imgs/monitor/mapTypeBg.png") no-repeat center;
            background-size: 100% 100%;

            .targetArea {
                position: absolute;
                top: calc(3vh + 12px);
                min-width: calc(8vw + 3.5vh);
                max-height: calc(257px - 12px);
                background-color: #fff;
                border-radius: 4px;
                padding: 6px 0;
                overflow-x: hidden;
                box-sizing: content-box;

                &::-webkit-scrollbar {
                    display: none;
                }

                li {
                    height: 34px;
                    color: #606266;
                    font-size: 14px;
                    line-height: 34px;
                    padding: 0 20px;
                    white-space: nowrap;
                    cursor: pointer;

                    &:hover {
                        background-color: #f5f7fa;
                    }
                }
            }

            .el-input {
                width: 8vw;

                input {
                    color: #fff;
                }
            }

            >p {
                display: inline-block;
                width: 3.5vh;
                height: 3.5vh;
                line-height: 3.5vh;
                cursor: pointer;
            }
        }
    }

    .citySelect {
        display: flex;
        justify-content: space-between;
        width: calc(25vw + (20vw - 16vw - 3.5vh));
        height: 100%;

        .citySelectBar {
            width: 16vw;
            height: 100%;
            background: url("../assets/imgs/monitor/positionBg.png") no-repeat center;
            background-size: 100% 100%;
        }

        .el-select {
            width: 8vw;
        }

        >.el-select {
            width: 9vw;
            background: url("../assets/imgs/monitor/mapTypeBg.png") no-repeat center;
            background-size: 100% 100%;
        }
    }
}

.areaSearch>.el-input input {
    width: 8vw;
    height: 3.5vh;
    line-height: 3.5vh;
    background-color: transparent;
    border-color: transparent !important;
}

.targetAreaKey {
    color: #409eff !important;
}

#monitor .el-select:hover,
#monitor .el-select:focus {
    outline: none !important;
    border: none !important;
}

.el-select-dropdown__item {
    color: #606266;
    padding: 0 20px;
}

#monitor .el-select .el-input__inner {
    height: 3.5vh;
    line-height: 3.5vh;
    background-color: transparent;
    border-color: transparent !important;
    color: #fff;
    font-size: 1.2vh;
}

#monitor .el-input.el-input--suffix .el-input__suffix {
    right: 8px;
}

#monitor .el-select .el-input.is-focus .el-input__inner,
#monitor .el-select .el-input__inner:focus,
#monitor .el-select .el-input__inner:hover {
    border-color: transparent !important;
    outline: none;
}

#monitor i.el-select__caret.el-input__icon {
    position: relative;
}

#monitor .el-select .el-input .el-select__caret {
    color: #fff;
}

#monitor .el-select__caret.el-input__icon::before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#monitor .el-input.is-disabled .el-input__inner {
    background-color: transparent;
    cursor: default !important;
}

#monitor .el-input.is-disabled .el-input__icon {
    cursor: default !important;
}

#monitor .popper__arrow {
    display: none !important;
}

.noInfo {
    text-align: center;
    line-height: 3vh;
    color: #777;
}


.my-style {
    width: 19.5vw;
    height: 4.5vh;
    clip-path: polygon(0% 100%, 12% 0%, 88% 0%, 100% 100%);
}

.my-style>img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -45%);
    height: 4.5vh;
}

/*父容器*/
.my-style {
    overflow: hidden;
    position: relative;
    /*设置为相对*/
}

/*图片*/
img {
    border: none;
}

/*流光（采用伪类实现，当然也可以是子元素）*/
.my-style:after {
    content: "";
    position: absolute;
    /*相对父级绝对定位*/
    width: 60px;
    height: 100%;
    top: 0;
    /*起始位置*/
    overflow: hidden;
    z-index: 9;
    /*背景渐变（兼容性写法）*/
    background: -moz-linear-gradient(left,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%);
    background: -o-linear-gradient(left,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%);
    background: linear-gradient(left,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%);
    background: -webkit-linear-gradient(left,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%);
    -webkit-transform: skewX(-25deg);
    /*倾斜*/
    -moz-transform: skewX(-25deg);
    transform: skewX(-25deg);
    animation: light 5s infinite;
}

@keyframes light {
    from {
        left: -30vw;
    }

    to {
        left: 40vw;
    }
}
</style>